
import { Github, Linkedin, Mail, ExternalLink } from 'lucide-react';
const Footer = () => {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-tech-dark py-8 border-t border-tech-charcoal/30">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <span className="font-orbitron text-xl font-light text-orange-300">V3DSTUDIO</span>
            <p className="text-foreground/70 text-sm mt-2">
              © {currentYear} | Všechna práva vyhrazena
            </p>
          </div>
          
          <div className="flex items-center gap-6 my-4 md:my-0">
            <a 
              href="https://linktr.ee/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-foreground/70 hover:text-tech-blue transition-colors flex items-center gap-1" 
              aria-label="Linktree"
            >
              <span>Linktree</span>
              <ExternalLink size={16} />
            </a>
          </div>
          
          <div className="flex items-center space-x-4">
            <a href="#" className="text-foreground/70 hover:text-tech-blue transition-colors" aria-label="GitHub">
              <Github size={20} />
            </a>
            <a href="#" className="text-foreground/70 hover:text-tech-blue transition-colors" aria-label="LinkedIn">
              <Linkedin size={20} />
            </a>
            <a href="mailto:info@example.com" className="text-foreground/70 hover:text-tech-blue transition-colors" aria-label="Email">
              <Mail size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;
